import React from "react";
import { motion } from "framer-motion";
import "./Modelo.css";
import "components/proyecto/container/ProjectDetails.css";
import AccordionBullets from "./AccordionBullets";
import Login from "auth/login";
import { useNavigate } from "react-router-dom";
import Link from '@mui/material/Link';

/**
 * Componente que muestra el contenido estático del documento
 * "Nivel de Madurez Multidimensional de EBCTs" con la misma
 * estructura de secciones que aparece en Notion. 
 * Se agregan divs de placeholder para que configures o subas
 * tus imágenes según necesites.
 */
export default function Modelo() {
    const rlItems = [
        { id: "1", title: "Customer Readiness Level (CRL):", content: "Evalúa la preparación del proyecto en relación con su base de clientes. Mide el nivel de comprensión, validación y adopción de la solución por parte del mercado objetivo, incluyendo el grado de interacción con usuarios, la validación del problema y solución, y el avance hacia ventas o compromisos comerciales." },
        { id: "2", title: "Business Readiness Level (BRL):", content: "Madurez del modelo de negocio del proyecto. Evalúa si el proyecto tiene un modelo de negocio sólido y viable, incluyendo la propuesta de valor, el mercado objetivo, la estrategia de ingresos y la capacidad para escalar." },
        { id: "3", title: "Technology Readiness Level (TRL):", content: "Evalúa el estado de desarrollo de la tecnología del proyecto. Va desde la investigación básica y el desarrollo de prototipos hasta la validación en entornos operativos reales. Indica cuán cerca está la tecnología de ser implementada comercialmente." },
        { id: "4", title: "Intellectual Property Readiness Level (IPRL):", content: "Esta dimensión busca medir el estado de desarrollo de la estrategia de propiedad intelectual del proyecto. Evalúa la identificación, protección y gestión de los derechos de propiedad intelectual, como patentes, marcas y derechos de autor." },
        { id: "5", title: "Team Readiness Level (TmRL):", content: "Mide las competencias, preparación y alineación del equipo del proyecto. Considera la experiencia y habilidades de los miembros del equipo, así como su capacidad para trabajar juntos de manera efectiva y abordar los desafíos del proyecto." },
        { id: "6", title: "Funding Readiness Level (FRL):", content: "Esta dimensión mide la preparación del proyecto para obtener financiamiento. Evalúa la capacidad del equipo para identificar, asegurar y gestionar los fondos necesarios para llevar el proyecto al mercado y escalar." },
    ];

    const navigate = useNavigate()

    return (
        <div className="containerMultipleChoiceTabs">
            <div className="mxAuto">
                <div className="card">
                    <motion.div
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="headerRow"
                    >
                        {/* Título principal */}

                        <div className="title">Nivel de Madurez Multidimensional de Proyectos Innovadores</div>
                        {/* Título del proyecto */}

                    </motion.div>
                    <motion.div
                        className="wrapperMotion"
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                    >




                        {/* Sección de introducción */}
                        <h2 className="sectionHeading">Descripción general</h2>
                        <p className="paragraph">
                            El modelo KTH Innovation Readiness Level (KTH IRL) consta de varios niveles que indican el grado de preparación y madurez de un proyecto innovador en múltiples dimensiones. Estas dimensiones incluyen cliente, tecnología, mercado, equipo, finanzas y propiedad intelectual, entre otras. Cada nivel proporciona una guía sobre lo que debe lograrse para avanzar al siguiente.
                        </p>

                        <div className="gridContainer_1_logeado">
                            {/*
                            <div className="gridSection1">
                                <h2 className="sectionHeading">Cómo funciona</h2>
                                
                                <div className="imagePlaceholder">
                                    <img src={`/images/go/Proceso-RLs.webp`} />
                                </div>
                            </div> */}
                            
                            <div className="gridSection2">
                                
                                <h2 className="sectionHeading">Dimensiones del modelo</h2>
                                <AccordionBullets bullets={rlItems} expanded={true} />
                                <div>
                                <br></br>
                                <h2 className="sectionHeading">Referencia</h2>
                                <p className="paragraph">
                                    La evaluación disponible en esta página y el informe generado se basa en el modelo KTH Innovation Readiness Level, desarrollado por KTH Innovation bajo la licencia Creative Commons Attribution Non Commercial Share Alike 4.0 International (CC BY-NC-SA 4.0). El modelo completo es accesible públicamente a través del siguiente enlace: <a target="_blank" href="https://kthinnovationreadinesslevel.com/">https://kthinnovationreadinesslevel.com/</a>
                                </p>
                            </div>
                            </div>
                        </div>
                        <div className="gridContainer_2">
                            
                        </div>
                        {/* Sección: Dimensiones Principales */}


                    </motion.div>
                </div>
            </div>
        </div>
    );
}